// utils/squareErrorUtils.ts
export function getSquareErrorMessage(code) {
  switch (code) {
    case 'CARD_DECLINED':
      return 'Your card was declined. Please use a different card.';
    case 'CARD_DECLINED_VERIFICATION_REQUIRED':
      return 'Card declined — verification is required. Please verify your card details.';
    case 'VERIFY_CVV_FAILURE':
      return 'The CVV code is incorrect. Please try again.';
    case 'VERIFY_AVS_FAILURE':
      return 'Billing address verification failed. Please check your address.';
    case 'INVALID_CARD':
      return 'The card number entered is invalid. Please try again.';
    case 'INSUFFICIENT_FUNDS':
      return 'Your card has insufficient funds.';
    case 'CARD_EXPIRED':
      return 'This card has expired. Please use another one.';
    case 'GENERIC_DECLINE':
      return 'Payment was declined. Please contact your bank.';
    case 'CVV_FAILURE':
      return 'The security code (CVV) is incorrect.';
    case 'ADDRESS_VERIFICATION_FAILURE':
      return 'The billing address verification failed.';
    case 'TEMPORARY_ERROR':
      return 'Temporary error occurred. Please try again later.';
    case 'INVALID_EXPIRATION':
      return 'Invalid expiry date.';
    default:
      return 'An unknown error occurred. Please try again or contact support.';
  }
}
